import clsx from 'clsx';
import { APPS } from 'constants/appModules';
import { PATHS } from 'constants/paths';
import { useDebouncedValue } from 'hooks/useDebouncedValue';
import { useEffect, useRef, useState } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';

import styles from './Sidebar.module.scss';
import SidebarContentWellGuardian from './components/SidebarContentWellGuardian';

type Props = {
  isOpen: boolean;
  onSidebarChanged: () => void;
  collapsed: boolean;
};

export const useSidebar = ({ isOpen, collapsed }: Props) => {
  const navigate = useNavigate();
  const currentApp = 'WELL_GUARDIAN';
  const isWellGuardianDisabled = false;

  const [selectedApp, setSelectedApp] = useState<HTMLElement | string>(currentApp);
  const [isAppChanged, setAppChanged] = useState<boolean>(false);
  const moduleSelectContainer = useRef(null);

  const isOpenDelayed = useDebouncedValue(isOpen, parseInt(styles.transitionDurationInMs));

  // open and close are specific selector names in css to track the sidebar state
  const getStylePerState = (basicStyle: string) =>
    clsx(basicStyle, isOpen ? styles.open : styles.close);

  const handleLinkChange = () => PATHS.HOME;

  const onChangeApp = () => {
    setAppChanged(true);
  };

  // this useEffect is used to set the selected app , when moving back to the previous page
  useEffect(() => {
    setSelectedApp(APPS.WELL_GUARDIAN);
  }, [currentApp]);

  // route to the new app, when selected app has changed
  useEffect(() => {
    if (isAppChanged) {
      navigate(generatePath(handleLinkChange()));
    }
    setAppChanged(false);
  }, [navigate, isAppChanged, selectedApp]);

  // Only show text when sidebar is fully open (delayed) and not collapsed
  const getSideBarComponentToRender = () => {
    return <SidebarContentWellGuardian collapsed={collapsed} isOpen={isOpen} />;
  };

  return {
    getStylePerState,
    isOpenDelayed,
    moduleSelectContainer,
    onChangeApp,
    isWellGuardianDisabled,
    getSideBarComponentToRender,
  };
};
